export default __webpack_public_path__ + "static/media/podcast_icon_resources_page-removebg-preview.9170271b.png";